import React from "react";
import { format, parseISO } from "date-fns";
import default_image from "../../assets/images/history/history-4.png";
import { Link } from "react-router-dom";
import { scrollToTop } from "../../utils/scrollUtils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const getIcon = (type) => {
  switch (type) {
    case "Share":
      return "fa-solid fa-share";
    case "Video":
      return "fa-brands fa-youtube";
    case "Article":
      return "fas fa-eye";
    default:
      return "fa-brands fa-facebook";
  }
};

function Post({
  type,
  message,
  full_picture,
  created_time,
  permalink_url,
  btn_label,
  target,
}) {
  // Formatear la fecha
  function formatDate(date) {
    const parsedDate = parseISO(date);
    return format(parsedDate, "dd/MM/yyyy");
  }
  return (
    <div className="tp-event-3-item col-xl-4 col-lg-4 col-md-6 mb-30">
      <div className="tp-event-3-thumb fix">
        <div className="tp-event-3-thumb fix">
          {Array.isArray(full_picture) && full_picture.length > 1 ? (
            <div style={{ display: "flex", overflowX: "auto", scrollSnapType: "x mandatory", gap: "10px", width: "100%", height: "100%" }}>
              {full_picture.map((img, idx) => (
                <img key={idx} src={img} alt={`picture-${idx}`} loading="lazy" style={{ minWidth: "100%", scrollSnapAlign: "center", objectFit: "cover" }} />
              ))}
            </div>
          ) : (
            <div style={{ position: "relative", width: "100%", height: "100%" }}>
              <img src={Array.isArray(full_picture) ? full_picture[0] : full_picture} alt="full_picture" loading="lazy" />
              {(type === "Video" || btn_label?.toLowerCase().includes("video") || permalink_url?.includes("watch") || permalink_url?.includes("video")) && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "50px",
                    height: "50px",
                    background: "rgba(0, 0, 0, 0.65)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "20px",
                    pointerEvents: "none",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                  }}
                >
                  <i className="fa-solid fa-play" style={{ marginLeft: "3px" }}></i>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="tp-event-3-content-wrap">
        <div className="tp-event-3-content">
          <div className="tp-event-3-meta">
            <span>
              <i className="fa-light fa-calendar-days" />
              {formatDate(created_time)}
            </span>
            <span>
              <i className="fa-solid fa-user" />
              Municipalidad Distrital de Pallán
            </span>
          </div>
          <p
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {message}
          </p>
        </div>
        <div className="tp-event-3-btn-box d-block d-md-flex">
          {permalink_url ? (
            <Link
              className="tp-btn-border-sm w-100 text-center"
              to={permalink_url}
              target={target}
              onClick={() => {
                if (target !== "_blank") {
                  scrollToTop();
                }
              }}
            >
              <i className={`${getIcon(type)} mr-5`}></i>
              <span>{btn_label}</span>
            </Link>
          ) : (
            <a
              className="tp-btn-border-sm w-100 text-center"
              href={Array.isArray(full_picture) ? full_picture[0] : full_picture}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className={`${getIcon(type)} mr-5`}></i>
              <span>{btn_label}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

function Posts({ data }) {
  return (
    <div
      className="row"
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {data.map(
        (post, index) =>
          post.message && (
            <Post
              key={index}
              message={post.message}
              full_picture={
                post.full_picture ? post.full_picture : default_image
              }
              created_time={post.created_time}
              permalink_url={post.permalink_url}
              target={post.target ? post.target : "_blank"}
              btn_label={post.btn_label ? post.btn_label : "Ver en Facebook"}
              type={post.type ? post.type : "Facebook"}
            />
          )
      )}
    </div>
  );
}

export default Posts;
